
<template>
  <div class="dhmap-wrapper gushuGisPage">
    <div class="search">
      <van-field
        v-model="selectZqName"
        is-link
        readonly
        placeholder="选择政区"
        @click="selectCityShow = true"
      />
      <van-field
        v-model="selectTreeType"
        is-link
        readonly
        placeholder="树木类型"
        @click="selectTreeTypeShow = true"
      />
      <van-field
        v-model="selectTreeGrade"
        is-link
        readonly
        placeholder="树木等级"
        @click="selectTreeGradeShow = true"
      />
    </div>
    <div id="map" ref="zrqmap"></div>
    <div class="leftNav">
      <div class="leftLi">
        <div class="leftLiImg" @click="getJumpUrl">
          <img :src="baseUrl + 'oldtree/shuju.png'" />
        </div>
      </div>
      <div class="leftLi">
        <div class="leftLiImg" @click="getJumpDt">
          <span class="oldtreeNum" v-if="mapNum"></span>
          <img :src="baseUrl + 'oldtree/dongtai.png'" />
        </div>
      </div>
      <div class="leftLi">
        <div class="leftLiImg" @click="getLocation">
          <img :src="baseUrl + 'oldtree/dingwei.png'" />
        </div>
      </div>
    </div>
    <van-popup
      v-model="showSlider"
      position="bottom"
      :overlay="false"
      :closeable="false"
      overlay-class="showSlider"
      @closed="addrClose"
      :style="{
        background: 'transparent',
        width: '80%',
        margin: 'auto !important',
        marginBottom: '1.33333rem',
        marginLeft: '6%',
      }"
    >
      <span class="close" @click="showSlider = false">
        <van-icon name="cross" />
      </span>
      <div class="addrList" v-if="addrList && addrList.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
        >
          <van-cell
            class="addrLi dis_flex"
            @click="addrChange(index, item)"
            v-for="(item, index) in addrList"
            :key="item.id"
          >
            <span class="addrIconWrap">
              <van-icon name="location-o" class="addrIcon" />
            </span>
            <div class="addrBox">
              <p class="addrText">
                {{ item.xianName + item.xiangName + item.cunName }}
              </p>
              <span class="addrTip"
                >{{ item.entryName }}（{{ item.treeClasses }}）距我
                {{ item.distance }}km</span
              >
            </div>
          </van-cell>
        </van-list>
      </div>
      <span v-else class="empty">当前无数据</span>
    </van-popup>
    <!-- 选择政区组件 -->
    <van-popup v-model="selectCityShow" position="bottom" class="areaPicker">
      <area-select
        :areaSource="areaData"
        :selectType="selectType"
        @setData="changeArea"
      ></area-select>
    </van-popup>
    <!-- 选择树木类型-->
    <van-popup v-model="selectTreeTypeShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="treeTypeData"
        value-key="dictName"
        @cancel="cancelTreeType"
        @confirm="saveTreeType"
      />
    </van-popup>

    <!-- 选择树木等级-->
    <van-popup v-model="selectTreeGradeShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="gushuLevelData"
        value-key="dictName"
        @cancel="cancelTreeGrade"
        @confirm="saveTreeGrade"
      />
    </van-popup>
  </div>
</template>

<script>
/* eslint-disable */
import "ol/ol.css";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState, mapMutations } from "vuex";
import { layersConfig } from "@/utils/mapLayers";
import { locateStyleCollection } from "@/utils/MapIcons";
import { getWidth } from "ol/extent.js";
import { GeoJSON ,WFS} from "ol/format.js";
 
import VectorSource from "ol/source/Vector.js";
import { Vector as VectorLayer } from "ol/layer.js";
import { Fill, Stroke, Style, Icon } from "ol/style.js";
import { get as getProjection } from "ol/proj.js";
import TileGrid from "ol/tilegrid/TileGrid.js";
import XYZ from "ol/source/XYZ.js";
import { Map, View } from "ol";
// import _ from 'lodash'
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { Tile as TileLayer } from "ol/layer.js";
import TileWMS from "ol/source/TileWMS.js";
import { defaults as defaultControls } from "ol/control.js";
import defaultIcon from "@/assets/asImages/user.png";
import {
  equalTo as equalToFilter,
  like as likeFilter,
  and as andFilter,
  or as orFilter,
  within as withinFilter,
} from "ol/format/filter.js";
import {
 addLocateLayerToMap,
  getLocateLayer,
} from "@/utils/MapUtils";
const areaSelect = () => import("@/components/manageModule/areaSelect");
export default {
  name: "gushuGis",
  components: {
    areaSelect,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      sysToken: "",
      sysClient: "",
      longitude: "",
      latitude: "",
      resolutions: null, //地图各级分辨率数组，默认为22级别
      uregionArr: ["sheng", "shi", "xian", "xiang", "cun"],
      single: false,
      map: null,
      tileGrid: null,
      startResolution: null,
      uregion: null,
      vectorSource: null, //定位数据源
      vectorLayer: null, //定位层
      projExtent: null, //
      search: {
        //搜索
        zqCode: "", //区域
        gushuLevel: "", //等级
        treeType: "", //防护等级
      },
      zqName: "", //区域名称
      regionList: [],
      //古树类型
      treeTypeData: [
        {
          dictCode: "",
          dictName: "全部",
        },
        {
          dictCode: "gsmm",
          dictName: "古树名木",
        },
        {
          dictCode: "gsq",
          dictName: "古树群",
        },
      ],
      gushuLevelData: [
        {
          dictCode: "",
          dictName: "全部",
        },
        {
          dictCode: "1",
          dictName: "一级",
        },
        {
          dictCode: "2",
          dictName: "二级",
        },
        {
          dictCode: "3",
          dictName: "三级",
        },
        {
          dictCode: "mingmu",
          dictName: "名木",
        },
      ],

      selectCityShow: false, //选择政区组件
      areaData: {}, //政区数据源
      selectZqName: "", //选择的区域
      selectTreeTypeShow: false, //树木类型组件
      selectTreeType: "", //树木类型
      selectTreeGradeShow: false, //树木等级组件
      selectTreeGrade: "", //树木等级
      selectType: "portion",
      mapNum: 0, //
      fieldValue: "",
      showSlider: false,
      addrList: [], //地址列表'

      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    this.sysToken = this.$route.query.sysToken;
    this.sysClient = this.$route.query.sysClient;
    //获取经纬度
    window.setPoints = this.setPoints;
    window.locateByNative = this.locateByNative;

    this.resolutions = new Array(22);
    this.projExtent = getProjection(layersConfig.projection).getExtent();
    this.startResolution = getWidth(this.projExtent) / 512;
    // this.longitude = "117.204998"; //parseFloat(this.$route.query.lon);
    // this.latitude = "31.849984"; //parseFloat(this.$route.query.lat);
    this.getPoints();
    // this.getLogin();
  },

  methods: {
    getLogin() {
      //获取用户信息
      let _this = this;
      _this.$api.slbkOldTree
        .getLogin()
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.areaData.regionCode = res.data.zqCode;
            _this.areaData.regionCodeName = res.data.zqName;
            _this.userinfo = res.data;
            _this.selectZqName = res.data.zqName;
            _this.search.zqCode = res.data.zqCode;
            this.initPage();
            this.bindMapEvt();
            this.mapGuShuList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPoints() {
      //获取经纬度地址信息
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(207, "");
      } else {
        //IOS
        // this.longitude = parseFloat(this.$route.query.lon);
        // this.latitude = parseFloat(this.$route.query.lat);
        window.webkit.messageHandlers.getPoints.postMessage(null);
        // this.initPage();
      }
      // console.log(1111111);
      // this.longitude = "117.2612"; //parseFloat(this.$route.query.lon);
      // this.latitude = "31.8823"; //parseFloat(this.$route.query.lat);
    },
    setPoints(data) {
      let pointsData = "";
      if (this.clientType == "android") {
        pointsData = window.android.getInfo(208, "");
        pointsData = pointsData.split("|");
        this.longitude = parseFloat(pointsData[0]);
        this.latitude = parseFloat(pointsData[1]);
      } else {
        pointsData = JSON.parse(data);
        this.longitude = parseFloat(pointsData.curLongitude);
        this.latitude = parseFloat(pointsData.curLatitude);
      }
      this.getLogin();
    },
    initPage() {
      let resolution = this.resolutions;
      for (var i = 0, ii = resolution.length; i < ii; ++i) {
        resolution[i] = this.startResolution / Math.pow(2, i);
      } //定义瓦片规格
      this.tileGrid = new TileGrid({
        extent: layersConfig.extend,
        resolutions: resolution,
        tileSize: layersConfig.tileSize,
      });
      console.log(this.tileGrid, "this.tileGrid");
      this.map = this.loadMap();
    },

    leftBoxClick() {
      this.leftBoxShow = !this.leftBoxShow;
    },
    addrClose() {
      this.showSlider = false;
      // this.searchEvent();
    },
    //跳转动态
    getJumpDt() {
      console.log("跳转动态列表");
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(209);
      } else {
        //IOS
        window.webkit.messageHandlers.getDtList.postMessage(null);
      }
    },
    //跳转页面
    getJumpUrl() {
      let _this = this;
      let jumpUrl = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      if (_this.clientType == "android") {
        window.android.getInfo(
          //安卓
          118,
          "" +
            jumpUrl +
            "/dhome-lzz-lzt-h5/#/treeAnalyse?sysToken=" +
            _this.sysToken +
            "&sysClient=" +
            _this.sysClient +
            "&zqCode=" +
            _this.search.zqCode +
            "&time=" +
            timestamp +
            ""
        );
      } else {
        //IOS
        window.webkit.messageHandlers.getJumpUrl.postMessage(
          "" +
            jumpUrl +
            "/dhome-lzz-lzt-h5/#/treeAnalyse?sysToken=" +
            _this.sysToken +
            "&sysClient=" +
            _this.sysClient +
            "&zqCode=" +
            _this.search.zqCode +
            "&time=" +
            timestamp +
            ""
        );
      }
    },
    //标记当前位置
    getLocation() {
      this.showSlider = !this.showSlider;
      console.log(this.showSlider, " this.showSlider ");
      let _this = this;
      let coordinate = [Number(_this.longitude), Number(_this.latitude)];

      var newFeature = new Feature({
        geometry: new Point(coordinate), //几何信息
        name: "标注点",
      });
      console.log(coordinate, "newFeature");
      this.vectorSource.addFeature(newFeature);
      this.map
        .getView()
        .setCenter([Number(_this.longitude), Number(_this.latitude)]);
    },
    //关联古树列表
    mapGuShuList() {
      let _this = this;
      this.$api.slbkOldTree
        .mapGuShuList(1, 999, {
          treeClasses: _this.search.gushuLevel,
          regionCode: _this.search.zqCode,
          currPoint: "point(" + _this.longitude + " " + _this.latitude + ")",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.addrList = res.data.list;
            // 加载状态结束
            _this.loading = false;
            _this.finished = true;
          } else {
            _this.$toast(res.msg);
          }
        });
    },
    addrChange(index, item) {
       console.log(item,"item1111")
      this.handleLocate(item.id, "ancient_tree_info");
    },
      handleLocate(objid, type) {
      if (objid && type) {
        this.showPropertyControl = false;
        this.showSearchControl = false;
        this.actLocate(this.map, objid);
      }
    },
    actLocate(map, objid) {
      let _this = this;
      fetch("https://www.ahlzz.com/geoserver/wfs", {
        method: "POST",
        body: new XMLSerializer().serializeToString(
          new WFS().writeGetFeature({
            srsName: "EPSG:4326",
            featureNS: "https://www.ahlzz.com/geoserver/gushu",
            featurePrefix: "gushu",
            featureTypes: ["ancient_tree_info"],
            outputFormat: "application/json",
            maxFeatures: 50,
            filter: equalToFilter("id", objid),
          })
        ),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var features = new GeoJSON().readFeatures(data);
          let vectorSource = getLocateLayer(map).getSource();
            
          vectorSource.clear();
          map.getOverlays().clear();
          var target = features[0];
          target.setStyle(
            new Style({
              stroke: new Stroke({
                color: "#f5f57a",
                width: 0.6,
              }),
            })
          );
          // target.setStyle(locateStyleCollection['geo_gushu_selected']);
          vectorSource.addFeature(target);
          map.getView().fit(vectorSource.getExtent());
        });
    },


    loadMap() {
      let _this = this;
      let ls = layersConfig.layers,
        len = layersConfig.layers.length,
        layers = [],
        clayer = null,
        _v = null;

      _this.uregion = _this.userinfo.zqCode; //用户所在政区Code
      let n =
        _this.uregion.length == "2"
          ? 1
          : _this.uregion.length == "4"
          ? 2
          : _this.uregion.length == "6"
          ? 3
          : _this.uregion.length == "9"
          ? 4
          : _this.uregion.length == "12"
          ? 5
          : ""; //用户所在政区等级
      for (var i = 0; i < len; i++) {
        _v = false;
        if (ls[i].maptype == "xyz" && ls[i].layerurl) {
          if (ls[i].checked == true) {
            _v = true;
          }
          clayer = new TileLayer({
            visible: _v,
            source: new XYZ({ url: ls[i].layerurl }),
          });
          clayer.dh_id = ls[i].id;
          layers.push(clayer);
        } else if (
          ls[i].maptype == "biz" &&
          "[object Object]" == Object.prototype.toString.call(ls[i].layerurl)
        ) {
          if (
            ls[i].checked &&
            layersConfig.initscale >= ls[i].layerurl.minscale &&
            layersConfig.initscale <= ls[i].layerurl.maxscale
          ) {
            _v = true;
          }
          if (ls[i].maptype == "biz" && ls[i].id == 70) {
            _v = true;
          }
          var CQL_FILTER = null;
          //政区过滤
          if (
            (ls[i].id == 20 && n <= 1) ||
            (ls[i].id == 30 && n <= 2) ||
            (ls[i].id == 40 && n <= 3) ||
            (ls[i].id == 50 && n <= 4) ||
            ls[i].id == 60
          ) {
            CQL_FILTER = "zq_code like '" + this.uregion + "%'";
            clayer = new TileLayer({
              visible: _v,
              source: new TileWMS({
                url: layersConfig.GeoServerWMS,
                params: {
                  LAYERS: ls[i].layerurl.layersource,
                  TILED: true,
                  CQL_FILTER: CQL_FILTER,
                },
                tileGrid: _this.tileGrid,
              }),
            });
          }
          if (ls[i].id == 70) {
            CQL_FILTER = "region_code like '" + this.uregion + "%'";
            clayer = new TileLayer({
              visible: _v,
              source: new TileWMS({
                url: ls[i].url,
                params: {
                  LAYERS: ls[i].layerurl.layersource,
                  TILED: true,
                  CQL_FILTER: CQL_FILTER,
                },
                tileGrid: _this.tileGrid,
              }),
            });
          }
          // clayer = new TileLayer({
          //   visible: _v,
          //   source: new TileWMS({
          //     url: layersConfig.GeoServerWMS,
          //     params: {
          //       LAYERS: ls[i].layerurl.layersource,
          //       TILED: true,
          //       CQL_FILTER: CQL_FILTER,
          //     },
          //     tileGrid: _this.tileGrid,
          //   }),
          // });
          clayer.dh_id = ls[i].id;
          clayer.dh_min = ls[i].layerurl.minscale;
          clayer.dh_max = ls[i].layerurl.maxscale;
          clayer.dh_type = "biz";
          if (
            (ls[i].id == 20 && n > 1) ||
            (ls[i].id == 30 && n > 2) ||
            (ls[i].id == 40 && n > 3) ||
            (ls[i].id == 50 && n > 4)
          ) {
            console.log(22);
          } else {
            layers.push(clayer);
          }
        }
      }
      // 定位layer
      _this.vectorSource = new VectorSource();
      _this.vectorLayer = new VectorLayer({
        source: _this.vectorSource,
        style: function () {
          return new Style({
            image: new Icon({
              src: defaultIcon,
            }),
          });
        },
      });
      layers.push(_this.vectorLayer);
      const map = new Map({
        target: "map",
        loadTilesWhileInteracting: true,
        layers: layers,
        controls: defaultControls({
          attribution: false,
          zoom: false,
          rotate: false,
        }),
        view: new View({
          projection: layersConfig.projection,
          center: [_this.longitude, _this.latitude], //[117.2612,31.8823],
          zoom: layersConfig.initscale,
          minZoom: layersConfig.minscale,
          maxZoom: layersConfig.maxscale,
          enableRotation: false,
          constrainResolution: true,
        }),
      });
      addLocateLayerToMap(map)
      return map;
    },
    getLayerById: function (id) {
      var layer = null;
      var layers = this.map.getLayers().getArray();
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].dh_id == id) {
          return layers[i];
        }
      }
      return layer;
    },
    bindMapEvt() {
      let _this = this;
      let currentZoom = layersConfig.initscale;
      _this.map.on("moveend", function () {
        //移动最后
        var zoom = _this.map.getView().getZoom(); //获取当前地图的缩放级别
        if (zoom != currentZoom) {
          currentZoom = zoom;
          var layers = _this.map.getLayers().getArray();
          for (var i = 0; i < layers.length; i++) {
            if (
              layers[i].dh_id &&
              layers[i].dh_type == "biz" &&
              layers[i].dh_id != 70
            ) {
              if (
                currentZoom >= layers[i].dh_min &&
                currentZoom <= layers[i].dh_max
              ) {
                layers[i].setVisible(true);
              } else {
                layers[i].setVisible(false);
              }
            }
          }
        }
      });
      this.map.on("singleclick", function (evt) {
        //地图单击事件
        var currentLayer = _this.getLayerById(70);
        var viewResolution = /** @type {number} */ (
          _this.map.getView().getResolution()
        );
        let source = currentLayer.getSource();
        console.log(source);
        var url = source.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          layersConfig.projection,
          { INFO_FORMAT: "application/json", FEATURE_COUNT: 5 }
        );
        if (url) {
          // url.replace("jy_geo_forestation_1","jy_geo_forestation")
          // url.replace("jy_geo_forestation_2","jy_geo_forestation")
          fetch(url)
            .then(function (response) {
              return response.json();
            })
            .then(function (geojsonObject) {
              try {
                var nowFeature = null;
                var features = new GeoJSON().readFeatures(geojsonObject);
                nowFeature = features[0];
                console.log(nowFeature, "nowFeature");
                if (nowFeature) {
                  _this.vectorSource.clear();
                  let obj = nowFeature.getProperties();
                  _this.vectorSource.addFeature(nowFeature);
                  let jumpUrl =
                    window.location.protocol + "//" + window.location.host + "";
                  let timestamp = Date.parse(new Date());
                  let linkUrl =
                    jumpUrl +
                    "/dhome-lzz-lzt-h5/#/gushuDetail?treeId=" +
                    obj.id +
                    "&sysToken=" +
                    _this.sysToken +
                    "&sysClient=" +
                    _this.sysClient +
                    "&time=" +
                    timestamp;
                  if (_this.clientType == "android") {
                    window.android.getInfo(118, String(linkUrl)); //安卓
                  } else {
                    //IOS
                    window.webkit.messageHandlers.getJumpUrl.postMessage(
                      String(linkUrl)
                    );
                  }
                }
              } catch (e) {
                console.log(e);
              }
            });
        }
      });
    },
    //选择城市回显
    changeArea(data) {
      let _this = this;
      if (data.code) {
        _this.selectZqName = data.name;
        _this.search.zqCode = data.code;
        _this.changeGushu();
      }
      _this.selectCityShow = false;
    },
    //选择树木类型
    saveTreeType(data) {
      let _this = this;
      _this.selectTreeType = data.dictName;
      _this.search.treeType = data.dictCode;
      _this.changeGushu();
      _this.selectTreeTypeShow = false;
    },
    cancelTreeType() {
      this.selectTreeTypeShow = false;
    },
    //选择树木等级
    saveTreeGrade(data) {
      let _this = this;
      _this.selectTreeGrade = data.dictName;
      _this.search.gushuLevel = data.dictName == "全部" ? "" : data.dictName;
      _this.changeGushu();
      _this.selectTreeGradeShow = false;
    },
    cancelTreeGrade() {
      this.selectTreeGradeShow = false;
    },
    changeGushu() {
      let _this = this;
      // let n = Number(_this.userinfo.regionLevel);
      var mapLayer = _this.getLayerById(70);
      var oriSource = mapLayer.getSource().getParams().LAYERS;
      let url = mapLayer.getSource().getUrls()[0];
      let gushuLevel = _this.search.gushuLevel ? _this.search.gushuLevel : "";
      let treeType = _this.search.treeType ? _this.search.treeType : "";

      var cql =
        "region_code like '" +
        _this.search.zqCode +
        "%'and tree_classes like '" +
        gushuLevel +
        "%'and tree_type like '" +
        treeType +
        "%'";
      // var cql = "region_code like '" + _this.search.zqCode + "%'";
      if (oriSource.indexOf("_1") > -1) {
        oriSource = oriSource.replace("_1", "") + "";
      } else if (oriSource.indexOf("_2") > -1) {
        oriSource = oriSource.replace("_2", "");
      } else {
        oriSource = oriSource + "";
      }
      if (this._tileGrid == null) {
        this._tileGrid = _this.tileGrid;
      } else {
        this._tileGrid = null;
      }
      var CQL_FILTER = cql;
      // var CQL_FILTER = _this.uregionArr[n - 1] + " like '" + this.uregion + "%'";
      mapLayer.setSource(
        new TileWMS({
          cacheSize: 1,
          url: url,
          params: { LAYERS: oriSource, TILED: true, CQL_FILTER: CQL_FILTER },
          tileGrid: _this._tileGrid,
        })
      );
      this.mapGuShuList();
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
.gushuGisPage {
  width: 100%;
  height: 100%;
  //所在地选址 所属分类
  .areaPicker.van-popup {
    width: 100%;
    height: 100%;
    padding-top: 5px;
  }
  .showSlider {
    background: transparent;
  }
  .close {
    position: absolute;
    top: 6px;
    right: 0;
    margin-right: 8px;
    font-size: 20px;
    z-index: 999;
  }
  .oldtreeNum {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 8px;
    height: 8px;
    line-height: 8px;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    background: #fd0100;
    font-size: 12px;
    color: #fff;
  }
  .empty {
    line-height: 200px;
    text-align: center;
    color: #999;
  }
  .addrList,
  .empty {
    padding: 10px 16px;
    width: 100%;
    display: block;
    background: #fff;
    margin: auto;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.19);
    border-radius: 6px;
    height: 200px;
    overflow: scroll;
    .addrLi {
      padding: 5px 0;
      position: relative;
      line-height: 12px;
      &.active {
        .addrIcon {
          display: inline-block;
        }
      }
    }

    .addrIconWrap {
      flex-shrink: 0;
      padding-right: 6px;
      width: 20px;
    }
    .addrIcon {
      font-size: 18px;
      color: #33b07a;
      display: none;
      margin-top: 2px;
      position: absolute;
      top: 12px;
      left: 0;
    }
    .addrText {
      font-size: 12px;
    }
    .addrTip {
      font-size: 10px;
      color: #494949;
    }
    .addrBox {
      width: 100%;
      padding-left: 22px;
    }
    .addrLi:last-child .addrBox {
      border: none;
    }
  }

  #map,
  .dhmap-wrapper {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 98%;
    position: absolute;
    top: 0;
    left: 1%;
    z-index: 999;
  }

  .liTap {
    position: absolute;
    right: 4px;
    top: 4px;
    background: #fd0100;
    width: 18px;
    height: 18px;
  }
  .leftNav {
    position: fixed;
    right: 4px;
    bottom: 60px;
    z-index: 999;
    .leftLi {
      padding-bottom: 16px;
      position: relative;

      .leftLiImg {
        background: #fff;
        width: 35px;
        height: 35px;
        z-index: 999;
        position: relative;
        border-radius: 50%;
        line-height: 35px;
        box-shadow: 0px 2px 4px 0px rgba(141, 154, 149, 0.26);
        text-align: center;
      }
      img {
        max-width: 20px;
        vertical-align: middle;
      }
    }
  }
  // .leftBox {
  //   background: #fff;
  //   border-radius: 24px;
  //   position: absolute;
  //   bottom: 16px;
  //   left: 0;
  //   width: 48px;
  //   padding: 6px 0 48px;
  //   text-align: center;
  //   .boxLi {
  //     padding: 6px 0;
  //   }
  // }

  .search {
    width: 98%;
    top: 10px;
    .van-cell {
      display: inline-block !important;
      width: 40% !important;
      padding: 0 5px;
      height: 35px;
      line-height: 35px;
      position: relative;
      margin-right: 4%;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;

      .van-icon {
        position: absolute;
        top: 5px;
        right: 0;
      }
    }
    .van-cell:nth-child(2) {
      width: 25% !important;
    }

    .van-cell:last-child {
      width: 25% !important;
      margin-right: 0;
    }
  }
}
</style>
<style lang="less">
.ol-zoom.ol-unselectable.ol-control {
  display: none !important;
}
</style>
